import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function discussionReducer(state = initialState.discussionState, action) {
    switch(action.type) {
        case types.GET_DISCUSSION_SECTIONS:   
        {        
            const sections = action.sections;
            return {
                ...state,
                sections
            };
        }
        case types.GET_DISCUSSIONS:   
        {        
            const discussions = action.payload.discussions;
            const sections = state.sections.map(section => {
                if(section.Link === action.payload.sectionLink){
                    return { ...section, discussions }
                  }
                  return section;
            });
            return {
                ...state,
                sections
            };
        }
        case types.CLEAR_DISCUSSIONS:
        {
            const sections = state.sections.map(section => {
                if(section.Link === action.sectionLink){
                    return { ...section, discussions: null }
                  }
                  return section;
            });
            return {
                ...state,
                sections
            };
        }
        case types.GET_POSTS:
        {
            return {
                ...state,
                currentDiscussion: action.currentDiscussion
            };
        }
        case types.CLEAR_POSTS:   
        {        
            return {
                ...state,
                currentDiscussion: null
            };
        }
        case types.UPDATE_POST_REPORT:   
        {        
            const currentDiscussion = {...state.currentDiscussion};
            currentDiscussion.Posts = {...currentDiscussion.Posts};
            currentDiscussion.Posts.Items = currentDiscussion.Posts.Items.map(post => {
                if(post.ID === action.payload.postID){
                    return { ...post, Reported: action.payload.reported }
                  }
                  return post;
            });
            return {
                ...state,
                currentDiscussion
            };
        }       
        case types.LOGOUT:
        {
            return {
                ...state,
                currentDiscussion: null
            };
        }
        default:
            return state;
    }
}